import { Box, IconButton, Tooltip } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import { ExamResponse } from '../types';
import Icons from '../../../components/icons';

export const getExamTableColumns = (
  handleViewEditClick: (exam: ExamResponse) => void,
  confirmDeleteExam: (examId: string) => void,
  deletingExamId: string | null,
  hasDeleteAccess: boolean
): GridColDef[] => [
  {
    field: 'name',
    headerName: 'Name',
    flex: 1,
    minWidth: 160,
    headerAlign: 'left',
    align: 'left'
  },
  {
    field: 'totalSubjects',
    headerName: 'Total Subjects',
    minWidth: 160,
    headerAlign: 'left',
    align: 'left',
    type: 'number',
    flex: 1
  },

  {
    field: 'actions',
    headerName: 'Actions',
    sortable: false,
    minWidth: 180,
    headerAlign: 'center',
    align: 'center',
    renderCell: (params) => {
      const row = params.row as ExamResponse;
      const deleting = deletingExamId === row.id;
      const TrashIcon = Icons.Delete;
      return (
        <Box>
          <Tooltip title='Edit'>
            <IconButton onClick={() => handleViewEditClick(row)}>
              <Icons.EditBlackOutlined />
            </IconButton>
          </Tooltip>
          {hasDeleteAccess && (
            <Tooltip title='Delete'>
              <IconButton
                onClick={() => confirmDeleteExam(row.id)}
                disabled={deleting}
              >
                <TrashIcon width={20} height={20} />
              </IconButton>
            </Tooltip>
          )}
        </Box>
      );
    }
  }
];
